export default "__VITE_ASSET__BSWS9dkz__"